import { SvgIcon } from '@mui/material';
import SvgAdyen from '../assets/payment-icons/adyen.svg.js';
import SvgBambora from '../assets/payment-icons/bambora.svg.js';
import SvgCoiney from '../assets/payment-icons/coiney.svg.js';
import SvgFreedomPay from '../assets/payment-icons/freedom-pay.svg.js';
import SvgIZettle from '../assets/payment-icons/i-zettle.svg.js';
import SvgKlarnaOld from '../assets/payment-icons/klarna-old.svg.js';
import SvgKlarna from '../assets/payment-icons/klarna.svg.js';
import SvgMobilePay from '../assets/payment-icons/mobile-pay.svg.js';
import SvgNets from '../assets/payment-icons/nets.svg.js';
import SvgSitooPayments from '../assets/payment-icons/sitoo-payments.svg.js';
import SvgSoftpay from '../assets/payment-icons/softpay.svg.js';
import SvgSwish from '../assets/payment-icons/swish.svg.js';
import SvgVerifone from '../assets/payment-icons/verifone.svg.js';
import SvgVippsMobilePay from '../assets/payment-icons/vipps-mobile-pay.svg.js';
import SvgVipps from '../assets/payment-icons/vipps.svg.js';
import { jsx } from 'react/jsx-runtime';

const AdyenIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgAdyen
});
const BamboraIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBambora
});
const CoineyIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCoiney
});
const FreedomPayIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFreedomPay
});
const IZettleIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgIZettle
});
const KlarnaOldIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgKlarnaOld
});
const KlarnaIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgKlarna
});
const MobilePayIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMobilePay
});
const NetsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgNets
});
const SitooPaymentsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSitooPayments
});
const SoftpayIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSoftpay
});
const SwishIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSwish
});
const VerifoneIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgVerifone
});
const VippsMobilePayIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgVippsMobilePay
});
const VippsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgVipps
});

export { AdyenIcon, BamboraIcon, CoineyIcon, FreedomPayIcon, IZettleIcon, KlarnaIcon, KlarnaOldIcon, MobilePayIcon, NetsIcon, SitooPaymentsIcon, SoftpayIcon, SwishIcon, VerifoneIcon, VippsIcon, VippsMobilePayIcon };
